var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Api, JsonRpc } from 'eosjs';
var accountPublickey;
var lynx;
if (typeof window !== undefined && typeof document !== undefined) {
    // @ts-ignore:
    lynx = window.lynxMobile;
    window.addEventListener('lynxMobileLoaded', function () {
        // @ts-ignore:
        lynx = window.lynxMobile;
    });
}
function logIfDebugEnabled(msg) {
    var debug = localStorage.getItem('DEBUG');
    if (debug === 'true') {
        console.log('IN WALLET: ' + msg);
    }
}
function makeSignatureProvider(network) {
    return {
        getAvailableKeys: function () {
            return __awaiter(this, void 0, void 0, function () {
                var arr;
                return __generator(this, function (_a) {
                    logIfDebugEnabled('In getAvailableKeys');
                    logIfDebugEnabled('Return Key: ' + accountPublickey);
                    arr = [accountPublickey];
                    return [2 /*return*/, arr];
                });
            });
        },
        sign: function (signatureProviderArgs) {
            return __awaiter(this, void 0, void 0, function () {
                var rpc, args, api, _txn, signatureResponse, signatureArray, respone;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logIfDebugEnabled('In Sign');
                            rpc = new JsonRpc(network.protocol + '://' + network.host + ':' + network.port);
                            args = {
                                rpc: rpc,
                                authorityProvider: undefined,
                                abiProvider: undefined,
                                signatureProvider: this,
                                chainId: undefined,
                                textEncoder: undefined,
                                textDecoder: undefined
                            };
                            api = new Api(args);
                            return [4 /*yield*/, api.deserializeTransactionWithActions(signatureProviderArgs.serializedTransaction)];
                        case 1:
                            _txn = _a.sent();
                            return [4 /*yield*/, lynx.requestSignature(_txn)];
                        case 2:
                            signatureResponse = _a.sent();
                            logIfDebugEnabled('signature: ' + signatureResponse.signatures[0]);
                            signatureArray = [signatureResponse.signatures[0]];
                            respone = {
                                signatures: signatureArray,
                                serializedTransaction: signatureProviderArgs.serializedTransaction
                            };
                            return [2 /*return*/, respone];
                    }
                });
            });
        }
    };
}
export function lynxWalletProvider() {
    return function makeWalletProvider(network) {
        // Connection
        function connect(appName) {
            logIfDebugEnabled('In wallet connect');
            return new Promise(function (resolve, reject) {
                var tries = 0;
                function checkConnect() {
                    logIfDebugEnabled('Checking the state of lynx Object: ' + tries + ' : ' + lynx);
                    if (lynx)
                        return resolve(true);
                    tries++;
                    if (tries > 5)
                        return reject('Cannot connect to lynx wallet provider');
                    setTimeout(function () {
                        checkConnect();
                    }, 1000);
                }
                checkConnect();
            });
        }
        function discover(discoveryOptions) {
            logIfDebugEnabled('The discover() method of myWallet was called');
            return new Promise(function (resolve, reject) {
                var discoveryInfo = {
                    keys: [],
                    note: 'Wallet does not support discovery'
                };
                resolve(discoveryInfo);
            });
        }
        function disconnect() {
            return Promise.resolve(true);
        }
        function signArbitrary(data, userMessage) {
            // @ts-ignore:
            return lynx.requestArbitrarySignature({ data: data, whatFor: userMessage });
        }
        // Authentication
        function login(accountName) {
            return __awaiter(this, void 0, void 0, function () {
                var _accountName, accountState, perm, publicKey;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logIfDebugEnabled('The login method of myWallet was called');
                            return [4 /*yield*/, lynx.requestSetAccountName()];
                        case 1:
                            _accountName = _a.sent();
                            logIfDebugEnabled(_accountName);
                            if (!_accountName)
                                throw new Error('Account name was null');
                            return [4 /*yield*/, lynx.requestSetAccount(_accountName)];
                        case 2:
                            accountState = _a.sent();
                            if (!accountState)
                                throw new Error('Account state was null');
                            perm = accountState.account.permissions.find(function (x) { return x.perm_name === 'active'; });
                            publicKey = perm.required_auth.keys[0].key;
                            accountPublickey = publicKey;
                            logIfDebugEnabled(publicKey);
                            return [2 /*return*/, {
                                    accountName: _accountName,
                                    permission: 'active',
                                    publicKey: publicKey
                                }];
                    }
                });
            });
        }
        function logout(accountName) {
            var res = function m2() {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (true)
                            return [2 /*return*/, true];
                        return [2 /*return*/];
                    });
                });
            };
            return res();
        }
        var walletProvider = {
            id: 'EOS Lynx',
            meta: {
                name: 'EOS Lynx',
                shortName: 'EOS Lynx',
                description: 'EOS Lynx Wallet'
            },
            signatureProvider: makeSignatureProvider(network),
            connect: connect,
            discover: discover,
            disconnect: disconnect,
            login: login,
            logout: logout,
            signArbitrary: signArbitrary
        };
        return walletProvider;
    };
}
export default lynxWalletProvider;
//# sourceMappingURL=index.js.map